// Fallback para configuração runtime se as variáveis de build não estiverem disponíveis
const getRuntimeConfig = () => {
  if (typeof window !== 'undefined' && window.APP_CONFIG) {
    return window.APP_CONFIG;
  }
  return {};
};

const runtimeConfig = getRuntimeConfig();

// Verificar se as variáveis VUE_APP_* estão disponíveis (desenvolvimento) ou usar runtime config (produção)
const hasVueAppVars = typeof process !== 'undefined' && process.env && process.env.VUE_APP_API_BASE_URL;

const nodeEnv = (hasVueAppVars ? process.env.NODE_ENV : runtimeConfig.NODE_ENV) || 'production';
const apiBase = hasVueAppVars ? process.env.VUE_APP_API_BASE_URL : runtimeConfig.VUE_APP_API_BASE_URL;
const apiSped = hasVueAppVars ? process.env.VUE_APP_SPED_API_URL : runtimeConfig.VUE_APP_SPED_API_URL;
const debug = hasVueAppVars ? (process.env.VUE_APP_DEBUG === 'true') : runtimeConfig.VUE_APP_DEBUG;

export default {
  nodeEnv,
  apiBase,
  apiSped,
  debug
};